import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../common/auth/UserSlice';
import subscriptionReducer from '../common/subscription/SubscriptionSlice';
import billingReducer from '../common/subscription/BillingSlice';
import snackbarReducer from '../common/snackbar/SnackbarSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    subscription: subscriptionReducer,
    billing: billingReducer,
    snackbar: snackbarReducer,
  },
});
